/***
 * Created on 2024/3/29
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect} from 'react';
import {useQnapAuthAppVerifyCheck} from "../../hook/qnap_auth_app_verify_check";
import {useBoundedStore} from 'common/Store';
import {useTranslation} from "react-i18next";

function QnapAuthCheckStatus({enable}) {
    const { t } = useTranslation();
    const {status, device, passcode} = useQnapAuthAppVerifyCheck(enable);
    const store = useBoundedStore();

    useEffect(() => {
        if (status === 'valid') {
            sessionStorage.removeItem('timer');
            const url = new URL(location.href);
            const state = url.searchParams.get('state');
            const lang = url.searchParams.get('lang');
            if (state && state !== '') {
                location.href = `/login?${url.searchParams.toString()}`
            }
            else {
                location.href = '/login?state=/account';
            }
        }
        else if (status === 'reject') {
             store.globalAlert.setAlert(t('@Request denied by QNAP Authenticator. Please try sending a new request again.@'), 'error', true);
             setTimeout(() => {
                 location.href = `/signout${location.search}`;
             }, 3000);
        }
        return () => {
            sessionStorage.removeItem('timer');
        }
    }, [status]);

    return (
        <></>
    );
}

export default QnapAuthCheckStatus;